import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "tab-content rounded bg-white p-3" };
const _hoisted_2 = {
    class: "tab-pane fade show active",
    id: "standard-tab-pane",
    role: "tabpanel",
    "aria-labelledby": "standard-tab",
    tabindex: "0"
};
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-lg-6 col-12" };
const _hoisted_5 = { class: "form-floating mb-3" };
const _hoisted_6 = { class: "row" };
const _hoisted_7 = { class: "col-12 col-lg-6 d-flex align-items-center" };
const _hoisted_8 = { class: "w-100 form-floating mb-3" };
const _hoisted_9 = { class: "col-12 col-lg-6" };
const _hoisted_10 = ["src"];
const _hoisted_11 = { class: "row" };
const _hoisted_12 = { class: "col-12 col-lg-6 d-flex align-items-center" };
const _hoisted_13 = { class: "w-100 form-floating mb-3" };
const _hoisted_14 = { class: "col-12 col-lg-6" };
const _hoisted_15 = ["src"];
const _hoisted_16 = { class: "form-floating mb-3" };
const _hoisted_17 = { class: "form-floating mb-3" };
const _hoisted_18 = { class: "form-floating mb-3" };
const _hoisted_19 = { class: "form-floating mb-3" };
const _hoisted_20 = { class: "form-check mb-3" };
const _hoisted_21 = { class: "form-check mb-3" };
const _hoisted_22 = { class: "form-floating mb-3" };
const _hoisted_23 = { class: "form-floating mb-3" };
const _hoisted_24 = { class: "form-floating mb-3" };
const _hoisted_25 = { class: "form-floating mb-3" };
const _hoisted_26 = { class: "form-floating mb-3" };
const _hoisted_27 = { class: "form-floating mb-3" };
const _hoisted_28 = { class: "form-floating mb-3" };
const _hoisted_29 = { class: "form-floating mb-3" };
const _hoisted_30 = { class: "form-floating mb-3" };
const _hoisted_31 = { class: "form-floating mb-3" };
const _hoisted_32 = { class: "form-floating mb-3" };
const _hoisted_33 = { class: "form-floating mb-3" };
const _hoisted_34 = { class: "form-floating mb-3" };
const _hoisted_35 = { class: "form-floating mb-3" };
const _hoisted_36 = { class: "col-12 col-lg-6" };
const _hoisted_37 = { class: "input-group mb-3" };
const _hoisted_38 = { class: "form-floating" };
const _hoisted_39 = { class: "form-floating mb-3" };
const _hoisted_40 = { class: "form-floating mb-3" };
const _hoisted_41 = { class: "form-floating mb-3" };
const _hoisted_42 = ["value"];
const _hoisted_43 = { class: "form-check mb-3" };
const _hoisted_44 = { class: "form-check mb-3" };
const _hoisted_45 = { class: "form-floating mb-3" };
const _hoisted_46 = { class: "form-floating mb-3" };
const _hoisted_47 = { class: "form-floating mb-3" };
const _hoisted_48 = { class: "form-floating mb-3" };
const _hoisted_49 = { class: "form-floating mb-3" };
const _hoisted_50 = { class: "form-floating mb-3" };
const _hoisted_51 = { class: "form-floating mb-3" };
const _hoisted_52 = { class: "form-floating mb-3" };
const _hoisted_53 = { class: "form-floating mb-3" };
const _hoisted_54 = { class: "form-floating mb-3" };
const _hoisted_55 = { class: "form-floating mb-3" };
const _hoisted_56 = { class: "row" };
const _hoisted_57 = { class: "form-floating mb-3" };
const _hoisted_58 = ["id", "onUpdate:modelValue"];
const _hoisted_59 = ["for"];
const _hoisted_60 = { class: "row" };
const _hoisted_61 = { class: "w-100 form-floating mb-3" };
const _hoisted_62 = ["id", "onUpdate:modelValue"];
const _hoisted_63 = ["value"];
const _hoisted_64 = ["for"];
const _hoisted_65 = { class: "form-floating mb-3" };
const _hoisted_66 = { class: "form-floating mb-3" };
const _hoisted_67 = { class: "form-floating mb-3" };
const _hoisted_68 = { class: "form-floating mb-3" };
const _hoisted_69 = { class: "form-floating mb-3" };
const _hoisted_70 = { class: "form-floating mb-3" };
const _hoisted_71 = { class: "form-floating mb-3" };
const _hoisted_72 = { class: "form-floating mb-3" };
const _hoisted_73 = { class: "form-floating mb-3" };
const _hoisted_74 = {
    class: "tab-pane fade",
    id: "stripe-tab-pane",
    role: "tabpanel",
    "aria-labelledby": "stripe-tab",
    tabindex: "0"
};
const _hoisted_75 = { class: "row" };
const _hoisted_76 = { class: "col-lg-6 col-12" };
const _hoisted_77 = { class: "form-floating mb-3" };
const _hoisted_78 = { class: "form-floating mb-3" };
const _hoisted_79 = { class: "form-floating mb-3" };
const _hoisted_80 = {
    class: "tab-pane fade",
    id: "mailer-tab-pane",
    role: "tabpanel",
    "aria-labelledby": "mailer-tab",
    tabindex: "0"
};
const _hoisted_81 = { class: "row" };
const _hoisted_82 = { class: "col-lg-6 col-12" };
const _hoisted_83 = { class: "form-floating mb-3" };
const _hoisted_84 = { class: "form-floating mb-3" };
const _hoisted_85 = { class: "form-floating mb-3" };
const _hoisted_86 = { class: "form-floating mb-3" };
const _hoisted_87 = { class: "form-floating mb-3" };
const _hoisted_88 = {
    class: "tab-pane fade",
    id: "ai-preview-options-tab-pane",
    role: "tabpanel",
    "aria-labelledby": "ai-preview-options-tab",
    tabindex: "0"
};
const _hoisted_89 = { class: "row" };
const _hoisted_90 = { class: "col-lg-6 col-12" };
const _hoisted_91 = { class: "form-floating mb-3" };
const _hoisted_92 = { class: "form-floating mb-3" };
const _hoisted_93 = { class: "form-floating mb-3" };
const _hoisted_94 = ["value"];
const _hoisted_95 = { class: "col-lg-6 col-12" };
const _hoisted_96 = { class: "w-100 form-floating mb-3" };
const _hoisted_97 = ["onSubmit"];
const _hoisted_98 = { class: "row" };
const _hoisted_99 = { class: "col-lg-6 col-12" };
const _hoisted_100 = { class: "form-floating mb-3" };
const _hoisted_101 = ["id", "onUpdate:modelValue"];
const _hoisted_102 = ["for"];
const _hoisted_103 = { class: "form-floating mb-3" };
const _hoisted_104 = ["id", "onUpdate:modelValue"];
const _hoisted_105 = ["for"];
const _hoisted_106 = { class: "form-floating mb-3" };
const _hoisted_107 = ["id", "onUpdate:modelValue"];
const _hoisted_108 = ["value"];
const _hoisted_109 = ["for"];
const _hoisted_110 = { class: "col-lg-6 col-12" };
const _hoisted_111 = { class: "row" };
const _hoisted_112 = { class: "col-12 col-lg-6 d-flex align-items-center" };
const _hoisted_113 = { class: "w-100 form-floating mb-3" };
const _hoisted_114 = ["onInput", "id"];
const _hoisted_115 = ["for"];
const _hoisted_116 = { class: "col-12 col-lg-6" };
const _hoisted_117 = ["src"];
const _hoisted_118 = ["onClick"];
import TenantLayout from '@/Tenant/Layouts/TenantLayout.vue';
import { Head, router, useForm } from '@inertiajs/vue3';
import { responseMessages } from '@/Composables/responseMessages';
import { useConfirm } from 'primevue';
import { ref } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Edit',
    props: {
        settings: {
            type: Object,
            required: true
        },
        standardProductTypes: {
            type: Object,
            required: true
        },
        configuratorLayoutColorFields: {
            type: Object,
            required: true
        },
        configuratorLayoutFontFamilyFields: {
            type: Object,
            required: true
        },
        availableConfiguratorFonts: {
            type: Object,
            required: true
        },
        availableAiPreviewOptions: {
            type: Object,
            required: true
        },
        aiPreviewOptions: {
            type: Object,
            required: true
        }
    },
    setup(__props) {
        let { showPageFlashMessage, showErrorMessage } = responseMessages();
        const props = __props;
        const confirm = useConfirm();
        const aiPreviewOptions = ref(props.aiPreviewOptions);
        const settingsForm = useForm({
            name: props.settings.name,
            logoFilePath: props.settings.logoFilePath,
            newLogoFile: null,
            mailLogoFilePath: props.settings.mailLogoFilePath,
            newMailLogoFile: null,
            dimensionSheetPrice: props.settings.dimensionSheetPrice,
            minDpi: props.settings.minDpi,
            maxImageUploadSize: props.settings.maxImageUploadSize,
            mailOrderConfirmation: props.settings.mailOrderConfirmation,
            mailContact: props.settings.mailContact,
            mailOrderRequests: props.settings.mailOrderRequests,
            mailOrder: props.settings.mailOrder,
            mailReplyTo: props.settings.mailReplyTo,
            mailFooter: props.settings.mailFooter,
            imprintUrl: props.settings.imprintUrl,
            privacyUrl: props.settings.privacyUrl,
            tocUrl: props.settings.tocUrl,
            cancellationRightUrl: props.settings.cancellationRightUrl,
            externalCartUrl: props.settings.externalCartUrl,
            externalConfiguratorUrl: props.settings.externalConfiguratorUrl,
            externalApprovalUrl: props.settings.externalApprovalUrl,
            externalLoginUrl: props.settings.externalLoginUrl,
            privateCustomersAllowed: props.settings.privateCustomersAllowed,
            orderWithZeroPriceComponentAllowed: props.settings.orderWithZeroPriceComponentAllowed,
            address: props.settings.address,
            zipcode: props.settings.zipcode,
            city: props.settings.city,
            email: props.settings.email,
            phone: props.settings.phone,
            website: props.settings.website,
            manager: props.settings.manager,
            registerCourt: props.settings.registerCourt,
            registerNumber: props.settings.registerNumber,
            taxNumber: props.settings.taxNumber,
            vatId: props.settings.vatId,
            bankName: props.settings.bankName,
            iban: props.settings.iban,
            bic: props.settings.bic,
            mainColor: props.settings.mainColor,
            colors: Object.entries(props.settings.colors).map(([k, v]) => ({ key: k, value: v })) || [],
            fontFamilies: Object.entries(props.settings.fontFamilies).map(([k, v]) => ({ key: k, value: v })) || [],
            standardProductType: props.settings.standardProductType,
            offerDeliveryInfo: props.settings.offerDeliveryInfo,
            offerDeliveryTime: props.settings.offerDeliveryTime,
            offerPaymentInfo: props.settings.offerPaymentInfo,
            offerAdditionalInfos: props.settings.offerAdditionalInfos,
            offerFooter1: props.settings.offerFooter1,
            offerFooter2: props.settings.offerFooter2,
            offerFooter3: props.settings.offerFooter3,
            offerFooter4: props.settings.offerFooter4,
            configuratorAllowTemplates: props.settings.configuratorAllowTemplates,
            configuratorAllowAiImages: props.settings.configuratorAllowAiImages
        });
        const stripeForm = useForm({
            key: props.settings.stripeKey,
            secret: props.settings.stripeSecret,
            webhookSecret: props.settings.stripeWebhookSecret
        });
        const mailerForm = useForm({
            mailerHost: props.settings.mailerHost,
            mailerPort: props.settings.mailerPort,
            mailerEncryption: props.settings.mailerEncryption,
            mailerUsername: props.settings.mailerUsername,
            mailerPassword: props.settings.mailerPassword
        });
        const aiPreviewOptionForm = useForm({
            name: null,
            nameEn: null,
            code: null,
            imageFile: null
        });
        function update() {
            settingsForm.transform((data) => ({
                name: data.name,
                logo_file: data.newLogoFile,
                mail_logo_file: data.newMailLogoFile,
                dimension_sheet_price: data.dimensionSheetPrice,
                min_dpi: data.minDpi,
                max_image_upload_size: data.maxImageUploadSize,
                mail_order_confirmation: data.mailOrderConfirmation,
                mail_contact: data.mailContact,
                mail_order_requests: data.mailOrderRequests,
                mail_order: data.mailOrder,
                mail_reply_to: data.mailReplyTo,
                mail_footer: data.mailFooter,
                imprint_url: data.imprintUrl,
                privacy_url: data.privacyUrl,
                toc_url: data.tocUrl,
                cancellation_right_url: data.cancellationRightUrl,
                external_cart_url: data.externalCartUrl,
                external_configurator_url: data.externalConfiguratorUrl,
                external_approval_url: data.externalApprovalUrl,
                external_login_url: data.externalLoginUrl,
                private_customers_allowed: data.privateCustomersAllowed ? 1 : 0,
                order_with_zero_price_component_allowed: data.orderWithZeroPriceComponentAllowed ? 1 : 0,
                address: data.address,
                zipcode: data.zipcode,
                city: data.city,
                email: data.email,
                phone: data.phone,
                website: data.website,
                manager: data.manager,
                register_court: data.registerCourt,
                register_number: data.registerNumber,
                tax_number: data.taxNumber,
                vat_id: data.vatId,
                bank_name: data.bankName,
                iban: data.iban,
                bic: data.bic,
                main_color: data.mainColor,
                colors: Object.fromEntries(data.colors.map((c) => [c.key, c.value])),
                font_families: Object.fromEntries(data.fontFamilies.map((f) => [f.key, f.value])),
                standard_product_type: data.standardProductType,
                offer_delivery_info: data.offerDeliveryInfo,
                offer_delivery_time: data.offerDeliveryTime,
                offer_payment_info: data.offerPaymentInfo,
                offer_additional_infos: data.offerAdditionalInfos,
                offer_footer_1: data.offerFooter1,
                offer_footer_2: data.offerFooter2,
                offer_footer_3: data.offerFooter3,
                offer_footer_4: data.offerFooter4,
                configurator_allow_templates: data.configuratorAllowTemplates ? 1 : 0,
                configurator_allow_ai_images: data.configuratorAllowAiImages ? 1 : 0
            }))
                .submit('post', route('admin.tenantSettings.update'), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function updateStripe() {
            settingsForm.transform((data) => ({
                stripe_key: stripeForm.key,
                stripe_secret: stripeForm.secret,
                stripe_webhook_secret: stripeForm.webhookSecret
            }))
                .submit('post', route('admin.tenantSettings.updateStripe'), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function updateMailer() {
            mailerForm.transform((data) => ({
                mailer_host: data.mailerHost,
                mailer_port: data.mailerPort,
                mailer_encryption: data.mailerEncryption,
                mailer_username: data.mailerUsername,
                mailer_password: data.mailerPassword
            }))
                .submit('post', route('admin.tenantSettings.updateMailer'), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function createAiPreviewOption() {
            aiPreviewOptionForm.transform((data) => ({
                name: data.name,
                name_en: data.nameEn,
                code: data.code,
                image_file: data.imageFile
            }))
                .submit('post', route('admin.aiPreviewOptions.store'), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                    aiPreviewOptionForm.reset();
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function updateAiPreviewOption(aiPreviewOption) {
            aiPreviewOptionForm.transform(() => ({
                name: aiPreviewOption.name,
                name_en: aiPreviewOption.nameEn,
                code: aiPreviewOption.code,
                image_file: aiPreviewOption.imageFile
            }))
                .submit('post', route('admin.aiPreviewOptions.update', aiPreviewOption.uuid), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function removeAiPreviewOption(aiPreviewOption) {
            confirm.require({
                message: 'Soll die AI-Vorschau-Option wirklich gelöscht werden?',
                header: 'AI-Vorschau-Option löschen?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    router.delete(route('admin.aiPreviewOptions.destroy', aiPreviewOption.uuid), {
                        preserveScroll: true,
                        onSuccess: page => {
                            aiPreviewOptions.value = aiPreviewOptions.value.filter((item) => item.uuid !== aiPreviewOption.uuid);
                            showPageFlashMessage(page);
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Head), { title: "Standard-Einstellungen" }),
                _createVNode(TenantLayout, null, {
                    default: _withCtx(() => [
                        _cache[150] || (_cache[150] = _createElementVNode("h1", { class: "fw-bold mb-3" }, "Standard-Einstellungen", -1)),
                        _cache[151] || (_cache[151] = _createElementVNode("ul", {
                            class: "nav nav-underline mb-3",
                            role: "tablist"
                        }, [
                            _createElementVNode("li", {
                                class: "nav-item",
                                role: "presentation"
                            }, [
                                _createElementVNode("button", {
                                    class: "nav-link active",
                                    id: "standard-tab",
                                    "data-bs-toggle": "tab",
                                    "data-bs-target": "#standard-tab-pane",
                                    type: "button",
                                    role: "tab",
                                    "aria-controls": "standard-tab-pane",
                                    "aria-selected": "true"
                                }, "Standard")
                            ]),
                            _createElementVNode("li", {
                                class: "nav-item",
                                role: "presentation"
                            }, [
                                _createElementVNode("button", {
                                    class: "nav-link",
                                    id: "stripe-tab",
                                    "data-bs-toggle": "tab",
                                    "data-bs-target": "#stripe-tab-pane",
                                    type: "button",
                                    role: "tab",
                                    "aria-controls": "stripe-tab-pane",
                                    "aria-selected": "false"
                                }, "Stripe")
                            ]),
                            _createElementVNode("li", {
                                class: "nav-item",
                                role: "presentation"
                            }, [
                                _createElementVNode("button", {
                                    class: "nav-link",
                                    id: "mailer-tab",
                                    "data-bs-toggle": "tab",
                                    "data-bs-target": "#mailer-tab-pane",
                                    type: "button",
                                    role: "tab",
                                    "aria-controls": "mailer-tab-pane",
                                    "aria-selected": "false"
                                }, "E-Mail-Versand")
                            ]),
                            _createElementVNode("li", {
                                class: "nav-item",
                                role: "presentation"
                            }, [
                                _createElementVNode("button", {
                                    class: "nav-link",
                                    id: "ai-preview-options-tab",
                                    "data-bs-toggle": "tab",
                                    "data-bs-target": "#ai-preview-options-tab-pane",
                                    type: "button",
                                    role: "tab",
                                    "aria-controls": "ai-preview-options-tab-pane",
                                    "aria-selected": "false"
                                }, "AI-Vorschau-Optionen")
                            ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("form", {
                                    onSubmit: _cache[49] || (_cache[49] = _withModifiers(($event) => (update()), ["prevent"])),
                                    enctype: "multipart/form-data"
                                }, [
                                    _createElementVNode("div", _hoisted_3, [
                                        _createElementVNode("div", _hoisted_4, [
                                            _createElementVNode("div", _hoisted_5, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "name",
                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(settingsForm).name) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).name]
                                                ]),
                                                _cache[65] || (_cache[65] = _createElementVNode("label", { for: "name" }, "Firmen-Name", -1))
                                            ]),
                                            _cache[90] || (_cache[90] = _createElementVNode("h5", { class: "fw-bold" }, "Standard-Logo", -1)),
                                            _createElementVNode("div", _hoisted_6, [
                                                _createElementVNode("div", _hoisted_7, [
                                                    _createElementVNode("div", _hoisted_8, [
                                                        _createElementVNode("input", {
                                                            type: "file",
                                                            onInput: _cache[1] || (_cache[1] = ($event) => (_unref(settingsForm).newLogoFile = $event.target.files[0])),
                                                            class: "form-control",
                                                            id: "newLogoFile"
                                                        }, null, 32),
                                                        _cache[66] || (_cache[66] = _createElementVNode("label", { for: "newLogoFile" }, "Neues Logo", -1))
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_9, [
                                                    (_unref(settingsForm).logoFilePath)
                                                        ? (_openBlock(), _createElementBlock("img", {
                                                            key: 0,
                                                            src: _unref(settingsForm).logoFilePath,
                                                            class: "img-fluid rounded mb-3",
                                                            alt: "Firmen-Logo"
                                                        }, null, 8, _hoisted_10))
                                                        : _createCommentVNode("", true),
                                                    _cache[67] || (_cache[67] = _createElementVNode("p", { class: "form-text" }, "Aktuelles Logo", -1))
                                                ])
                                            ]),
                                            _cache[91] || (_cache[91] = _createElementVNode("h5", { class: "fw-bold" }, "Mail-Logo", -1)),
                                            _createElementVNode("div", _hoisted_11, [
                                                _createElementVNode("div", _hoisted_12, [
                                                    _createElementVNode("div", _hoisted_13, [
                                                        _createElementVNode("input", {
                                                            type: "file",
                                                            onInput: _cache[2] || (_cache[2] = ($event) => (_unref(settingsForm).newMailLogoFile = $event.target.files[0])),
                                                            class: "form-control",
                                                            id: "newMailLogoFile"
                                                        }, null, 32),
                                                        _cache[68] || (_cache[68] = _createElementVNode("label", { for: "newMailLogoFile" }, "Neues Mail-Logo", -1))
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_14, [
                                                    (_unref(settingsForm).mailLogoFilePath)
                                                        ? (_openBlock(), _createElementBlock("img", {
                                                            key: 0,
                                                            src: _unref(settingsForm).mailLogoFilePath,
                                                            class: "img-fluid rounded mb-3",
                                                            alt: "Firmen-Logo"
                                                        }, null, 8, _hoisted_15))
                                                        : _createCommentVNode("", true),
                                                    _cache[69] || (_cache[69] = _createElementVNode("p", { class: "form-text" }, "Aktuelles Logo", -1))
                                                ])
                                            ]),
                                            _cache[92] || (_cache[92] = _createElementVNode("h5", { class: "fw-bold" }, "Rechtliches", -1)),
                                            _createElementVNode("div", _hoisted_16, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "imprintUrl",
                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(settingsForm).imprintUrl) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).imprintUrl]
                                                ]),
                                                _cache[70] || (_cache[70] = _createElementVNode("label", { for: "imprintUrl" }, "Link - Impressum", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_17, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "privacyUrl",
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(settingsForm).privacyUrl) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).privacyUrl]
                                                ]),
                                                _cache[71] || (_cache[71] = _createElementVNode("label", { for: "privacyUrl" }, "Link - Datenschutz", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_18, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "tocUrl",
                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(settingsForm).tocUrl) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).tocUrl]
                                                ]),
                                                _cache[72] || (_cache[72] = _createElementVNode("label", { for: "tocUrl" }, "Link - AGBs", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_19, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "cancellationRightUrl",
                                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(settingsForm).cancellationRightUrl) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).cancellationRightUrl]
                                                ]),
                                                _cache[73] || (_cache[73] = _createElementVNode("label", { for: "cancellationRightUrl" }, "Link - Widerrufsrecht", -1))
                                            ]),
                                            _cache[93] || (_cache[93] = _createElementVNode("h5", { class: "fw-bold" }, "Firmen-Angaben, weitere Details", -1)),
                                            _createElementVNode("div", _hoisted_20, [
                                                _withDirectives(_createElementVNode("input", {
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    value: "1",
                                                    id: "privateCustomersAllowed",
                                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(settingsForm).privateCustomersAllowed) = $event))
                                                }, null, 512), [
                                                    [_vModelCheckbox, _unref(settingsForm).privateCustomersAllowed]
                                                ]),
                                                _cache[74] || (_cache[74] = _createElementVNode("label", {
                                                    class: "form-check-label",
                                                    for: "privateCustomersAllowed"
                                                }, "Private Einkäufer erlaubt (bei Aktivierung können private Kunden Bestellungen durchführen)", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_21, [
                                                _withDirectives(_createElementVNode("input", {
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    value: "1",
                                                    id: "orderWithZeroPriceComponentAllowed",
                                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_unref(settingsForm).orderWithZeroPriceComponentAllowed) = $event))
                                                }, null, 512), [
                                                    [_vModelCheckbox, _unref(settingsForm).orderWithZeroPriceComponentAllowed]
                                                ]),
                                                _cache[75] || (_cache[75] = _createElementVNode("label", {
                                                    class: "form-check-label",
                                                    for: "orderWithZeroPriceComponentAllowed"
                                                }, "Bestellungen mit null Euro Positionen erlaubt (bei Aktivierung können auch Bestellungen mit einem Preis von 0 € durchgeführt werden)", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_22, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "address",
                                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_unref(settingsForm).address) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).address]
                                                ]),
                                                _cache[76] || (_cache[76] = _createElementVNode("label", { for: "address" }, "Adresse", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_23, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "zipcode",
                                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_unref(settingsForm).zipcode) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).zipcode]
                                                ]),
                                                _cache[77] || (_cache[77] = _createElementVNode("label", { for: "zipcode" }, "PLZ", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_24, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "city",
                                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_unref(settingsForm).city) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).city]
                                                ]),
                                                _cache[78] || (_cache[78] = _createElementVNode("label", { for: "city" }, "Stadt", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_25, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "email",
                                                    class: "form-control",
                                                    id: "email",
                                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_unref(settingsForm).email) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).email]
                                                ]),
                                                _cache[79] || (_cache[79] = _createElementVNode("label", { for: "email" }, "E-Mail", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_26, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "phone",
                                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_unref(settingsForm).phone) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).phone]
                                                ]),
                                                _cache[80] || (_cache[80] = _createElementVNode("label", { for: "phone" }, "Telefon", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_27, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "website",
                                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_unref(settingsForm).website) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).website]
                                                ]),
                                                _cache[81] || (_cache[81] = _createElementVNode("label", { for: "website" }, "Website", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_28, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "manager",
                                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_unref(settingsForm).manager) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).manager]
                                                ]),
                                                _cache[82] || (_cache[82] = _createElementVNode("label", { for: "manager" }, "Manager/Geschäftsführer(in)", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_29, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "registerCourt",
                                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_unref(settingsForm).registerCourt) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).registerCourt]
                                                ]),
                                                _cache[83] || (_cache[83] = _createElementVNode("label", { for: "registerCourt" }, "Registergericht", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_30, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "registerNumber",
                                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_unref(settingsForm).registerNumber) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).registerNumber]
                                                ]),
                                                _cache[84] || (_cache[84] = _createElementVNode("label", { for: "registerNumber" }, "Registernummer", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_31, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "taxNumber",
                                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((_unref(settingsForm).taxNumber) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).taxNumber]
                                                ]),
                                                _cache[85] || (_cache[85] = _createElementVNode("label", { for: "taxNumber" }, "Steuernummer", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_32, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "vatId",
                                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((_unref(settingsForm).vatId) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).vatId]
                                                ]),
                                                _cache[86] || (_cache[86] = _createElementVNode("label", { for: "vatId" }, "Umsatzsteuer-ID", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_33, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "bankName",
                                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((_unref(settingsForm).bankName) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).bankName]
                                                ]),
                                                _cache[87] || (_cache[87] = _createElementVNode("label", { for: "bankName" }, "Bank-Name", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_34, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "iban",
                                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((_unref(settingsForm).iban) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).iban]
                                                ]),
                                                _cache[88] || (_cache[88] = _createElementVNode("label", { for: "iban" }, "IBAN", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_35, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "bic",
                                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((_unref(settingsForm).bic) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).bic]
                                                ]),
                                                _cache[89] || (_cache[89] = _createElementVNode("label", { for: "bic" }, "BIC", -1))
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_36, [
                                            _cache[121] || (_cache[121] = _createElementVNode("h5", { class: "fw-bold" }, "Konfigurator", -1)),
                                            _createElementVNode("div", _hoisted_37, [
                                                _createElementVNode("div", _hoisted_38, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        id: "dimensionSheetPrice",
                                                        type: "number",
                                                        class: "form-control",
                                                        min: "0",
                                                        step: "0.01",
                                                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => ((_unref(settingsForm).dimensionSheetPrice) = $event)),
                                                        required: ""
                                                    }, null, 512), [
                                                        [_vModelText, _unref(settingsForm).dimensionSheetPrice]
                                                    ]),
                                                    _cache[94] || (_cache[94] = _createElementVNode("label", { for: "dimensionSheetPrice" }, "Maßblatt-Preis pro Konfiguration", -1))
                                                ]),
                                                _cache[95] || (_cache[95] = _createElementVNode("span", { class: "input-group-text" }, "€", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_39, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "number",
                                                    class: "form-control",
                                                    id: "minDpi",
                                                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => ((_unref(settingsForm).minDpi) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).minDpi]
                                                ]),
                                                _cache[96] || (_cache[96] = _createElementVNode("label", { for: "minDpi" }, "Min. DPI für hochgeladene Bilder", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_40, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "number",
                                                    class: "form-control",
                                                    id: "maxImageUploadSize",
                                                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => ((_unref(settingsForm).maxImageUploadSize) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).maxImageUploadSize]
                                                ]),
                                                _cache[97] || (_cache[97] = _createElementVNode("label", { for: "maxImageUploadSize" }, "Max. Bildgröße in KB für hochgeladene Bilder", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_41, [
                                                _withDirectives(_createElementVNode("select", {
                                                    class: "form-select",
                                                    id: "standardProductType",
                                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => ((_unref(settingsForm).standardProductType) = $event))
                                                }, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.standardProductTypes, (productType, index) => {
                                                        return (_openBlock(), _createElementBlock("option", { value: index }, _toDisplayString(productType), 9, _hoisted_42));
                                                    }), 256))
                                                ], 512), [
                                                    [_vModelSelect, _unref(settingsForm).standardProductType]
                                                ]),
                                                _cache[98] || (_cache[98] = _createElementVNode("label", { for: "standardProductType" }, "Standard-Produkt-Typ (relevant für Benennung im Konfigurator)", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_43, [
                                                _withDirectives(_createElementVNode("input", {
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    value: "1",
                                                    id: "configuratorAllowTemplates",
                                                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event) => ((_unref(settingsForm).configuratorAllowTemplates) = $event))
                                                }, null, 512), [
                                                    [_vModelCheckbox, _unref(settingsForm).configuratorAllowTemplates]
                                                ]),
                                                _cache[99] || (_cache[99] = _createElementVNode("label", {
                                                    class: "form-check-label",
                                                    for: "configuratorAllowTemplates"
                                                }, "Vorlagen im Konfigurator erlauben", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_44, [
                                                _withDirectives(_createElementVNode("input", {
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    value: "1",
                                                    id: "configuratorAllowAiImages",
                                                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event) => ((_unref(settingsForm).configuratorAllowAiImages) = $event))
                                                }, null, 512), [
                                                    [_vModelCheckbox, _unref(settingsForm).configuratorAllowAiImages]
                                                ]),
                                                _cache[100] || (_cache[100] = _createElementVNode("label", {
                                                    class: "form-check-label",
                                                    for: "configuratorAllowAiImages"
                                                }, "KI-Bild-Generierungen im Konfigurator erlauben", -1))
                                            ]),
                                            _cache[122] || (_cache[122] = _createElementVNode("h5", { class: "fw-bold" }, "Externe Standard-URLs", -1)),
                                            _cache[123] || (_cache[123] = _createElementVNode("p", null, "Standard-URLs für die Weiterleitung zum globalen Warenkorb, Konfigurator etc., z.B. der Versendung von Angeboten und Konfigurations-Links", -1)),
                                            _createElementVNode("div", _hoisted_45, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "externalCartUrl",
                                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event) => ((_unref(settingsForm).externalCartUrl) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).externalCartUrl]
                                                ]),
                                                _cache[101] || (_cache[101] = _createElementVNode("label", { for: "externalCartUrl" }, "Warenkorb", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_46, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "externalConfiguratorUrl",
                                                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event) => ((_unref(settingsForm).externalConfiguratorUrl) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).externalConfiguratorUrl]
                                                ]),
                                                _cache[102] || (_cache[102] = _createElementVNode("label", { for: "externalConfiguratorUrl" }, "Konfigurator", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_47, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "externalApprovalUrl",
                                                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event) => ((_unref(settingsForm).externalApprovalUrl) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).externalApprovalUrl]
                                                ]),
                                                _cache[103] || (_cache[103] = _createElementVNode("label", { for: "externalApprovalUrl" }, "Freigabe", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_48, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "externalLoginUrl",
                                                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event) => ((_unref(settingsForm).externalLoginUrl) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).externalLoginUrl]
                                                ]),
                                                _cache[104] || (_cache[104] = _createElementVNode("label", { for: "externalLoginUrl" }, "Login-Seite", -1))
                                            ]),
                                            _cache[124] || (_cache[124] = _createElementVNode("h5", { class: "fw-bold" }, "E-Mails", -1)),
                                            _createElementVNode("div", _hoisted_49, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "mailOrderConfirmation",
                                                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event) => ((_unref(settingsForm).mailOrderConfirmation) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).mailOrderConfirmation]
                                                ]),
                                                _cache[105] || (_cache[105] = _createElementVNode("label", { for: "mailOrderConfirmation" }, "E-Mail - Auftragsbestätigungen", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_50, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "mailContact",
                                                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event) => ((_unref(settingsForm).mailContact) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).mailContact]
                                                ]),
                                                _cache[106] || (_cache[106] = _createElementVNode("label", { for: "mailContact" }, "E-Mail - Kontakt", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_51, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "mailOrderRequests",
                                                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event) => ((_unref(settingsForm).mailOrderRequests) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).mailOrderRequests]
                                                ]),
                                                _cache[107] || (_cache[107] = _createElementVNode("label", { for: "mailOrderRequests" }, "E-Mail - Anfragen", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_52, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "mailOrder",
                                                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event) => ((_unref(settingsForm).mailOrder) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).mailOrder]
                                                ]),
                                                _cache[108] || (_cache[108] = _createElementVNode("label", { for: "mailOrder" }, "E-Mail - Bestellungen", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_53, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "mailReplyTo",
                                                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event) => ((_unref(settingsForm).mailReplyTo) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).mailReplyTo]
                                                ]),
                                                _cache[109] || (_cache[109] = _createElementVNode("label", { for: "mailReplyTo" }, "E-Mail - Standard-Antwort-Mail", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_54, [
                                                _withDirectives(_createElementVNode("textarea", {
                                                    class: "form-control",
                                                    id: "mailFooter",
                                                    style: { "height": "100px" },
                                                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event) => ((_unref(settingsForm).mailFooter) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).mailFooter]
                                                ]),
                                                _cache[110] || (_cache[110] = _createElementVNode("label", { for: "mailFooter" }, "E-Mail - Fußzeile", -1))
                                            ]),
                                            _cache[125] || (_cache[125] = _createElementVNode("h5", { class: "fw-bold" }, "Farben, Schriftarten, Visualisierung", -1)),
                                            _createElementVNode("div", _hoisted_55, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "mainColor",
                                                    "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event) => ((_unref(settingsForm).mainColor) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).mainColor]
                                                ]),
                                                _cache[111] || (_cache[111] = _createElementVNode("label", { for: "mainColor" }, "Haupt-Farbe", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_56, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(settingsForm).colors, (entry, index) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        class: "col-12 col-lg-4 d-flex align-items-center",
                                                        key: index
                                                    }, [
                                                        _createElementVNode("div", _hoisted_57, [
                                                            _withDirectives(_createElementVNode("input", {
                                                                type: "text",
                                                                class: "form-control",
                                                                id: entry.key,
                                                                "onUpdate:modelValue": ($event) => ((entry.value) = $event)
                                                            }, null, 8, _hoisted_58), [
                                                                [_vModelText, entry.value]
                                                            ]),
                                                            _createElementVNode("label", {
                                                                for: entry.key
                                                            }, _toDisplayString(props.configuratorLayoutColorFields[entry.key]), 9, _hoisted_59)
                                                        ]),
                                                        _createElementVNode("div", {
                                                            class: "rounded ms-2 mb-3",
                                                            style: _normalizeStyle({ width: '30px', height: '30px', backgroundColor: entry.value })
                                                        }, null, 4)
                                                    ]));
                                                }), 128))
                                            ]),
                                            _createElementVNode("div", _hoisted_60, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(settingsForm).fontFamilies, (entry, index) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        class: "col-12 col-lg-4 d-flex align-items-center",
                                                        key: index
                                                    }, [
                                                        _createElementVNode("div", _hoisted_61, [
                                                            _withDirectives(_createElementVNode("select", {
                                                                class: "form-select",
                                                                id: 'fontFamilies' + entry.key,
                                                                "onUpdate:modelValue": ($event) => ((entry.value) = $event)
                                                            }, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.availableConfiguratorFonts, (fontOption, index) => {
                                                                    return (_openBlock(), _createElementBlock("option", { value: index }, _toDisplayString(fontOption), 9, _hoisted_63));
                                                                }), 256))
                                                            ], 8, _hoisted_62), [
                                                                [_vModelSelect, entry.value]
                                                            ]),
                                                            _createElementVNode("label", {
                                                                for: 'fontFamilies' + entry.key
                                                            }, _toDisplayString(props.configuratorLayoutFontFamilyFields[entry.key]), 9, _hoisted_64)
                                                        ])
                                                    ]));
                                                }), 128))
                                            ]),
                                            _cache[126] || (_cache[126] = _createElementVNode("h5", { class: "fw-bold" }, "E-Mails", -1)),
                                            _cache[127] || (_cache[127] = _createElementVNode("p", null, "Zeilen mit <br /> abtrennen.", -1)),
                                            _createElementVNode("div", _hoisted_65, [
                                                _withDirectives(_createElementVNode("textarea", {
                                                    class: "form-control",
                                                    id: "mailFooter",
                                                    style: { "height": "100px" },
                                                    "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event) => ((_unref(settingsForm).mailFooter) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).mailFooter]
                                                ]),
                                                _cache[112] || (_cache[112] = _createElementVNode("label", { for: "mailFooter" }, "E-Mail - Fußzeile", -1))
                                            ]),
                                            _cache[128] || (_cache[128] = _createElementVNode("h5", { class: "fw-bold" }, "Auftragsbestätigungen", -1)),
                                            _cache[129] || (_cache[129] = _createElementVNode("p", null, "Zeilen mit <br /> abtrennen.", -1)),
                                            _createElementVNode("div", _hoisted_66, [
                                                _withDirectives(_createElementVNode("textarea", {
                                                    class: "form-control",
                                                    id: "offerDeliveryInfo",
                                                    style: { "height": "100px" },
                                                    "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event) => ((_unref(settingsForm).offerDeliveryInfo) = $event))
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).offerDeliveryInfo]
                                                ]),
                                                _cache[113] || (_cache[113] = _createElementVNode("label", { for: "offerDeliveryInfo" }, "Lieferinformationen", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_67, [
                                                _withDirectives(_createElementVNode("textarea", {
                                                    class: "form-control",
                                                    id: "offerDeliveryTime",
                                                    style: { "height": "100px" },
                                                    "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event) => ((_unref(settingsForm).offerDeliveryTime) = $event))
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).offerDeliveryTime]
                                                ]),
                                                _cache[114] || (_cache[114] = _createElementVNode("label", { for: "offerDeliveryTime" }, "Lieferzeit", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_68, [
                                                _withDirectives(_createElementVNode("textarea", {
                                                    class: "form-control",
                                                    id: "offerPaymentInfo",
                                                    style: { "height": "100px" },
                                                    "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event) => ((_unref(settingsForm).offerPaymentInfo) = $event))
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).offerPaymentInfo]
                                                ]),
                                                _cache[115] || (_cache[115] = _createElementVNode("label", { for: "offerPaymentInfo" }, "Zahlungsinformationen", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_69, [
                                                _withDirectives(_createElementVNode("textarea", {
                                                    class: "form-control",
                                                    id: "offerAdditionalInfos",
                                                    style: { "height": "100px" },
                                                    "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event) => ((_unref(settingsForm).offerAdditionalInfos) = $event))
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).offerAdditionalInfos]
                                                ]),
                                                _cache[116] || (_cache[116] = _createElementVNode("label", { for: "offerAdditionalInfos" }, "Zusätzliche Informationen", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_70, [
                                                _withDirectives(_createElementVNode("textarea", {
                                                    class: "form-control",
                                                    id: "offerFooter1",
                                                    style: { "height": "100px" },
                                                    "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event) => ((_unref(settingsForm).offerFooter1) = $event))
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).offerFooter1]
                                                ]),
                                                _cache[117] || (_cache[117] = _createElementVNode("label", { for: "offerFooter1" }, "Fußzeile - Spalte 1", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_71, [
                                                _withDirectives(_createElementVNode("textarea", {
                                                    class: "form-control",
                                                    id: "offerFooter2",
                                                    style: { "height": "100px" },
                                                    "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event) => ((_unref(settingsForm).offerFooter2) = $event))
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).offerFooter2]
                                                ]),
                                                _cache[118] || (_cache[118] = _createElementVNode("label", { for: "offerFooter2" }, "Fußzeile - Spalte 2", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_72, [
                                                _withDirectives(_createElementVNode("textarea", {
                                                    class: "form-control",
                                                    id: "offerFooter3",
                                                    style: { "height": "100px" },
                                                    "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event) => ((_unref(settingsForm).offerFooter3) = $event))
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).offerFooter3]
                                                ]),
                                                _cache[119] || (_cache[119] = _createElementVNode("label", { for: "offerFooter3" }, "Fußzeile - Spalte 3", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_73, [
                                                _withDirectives(_createElementVNode("textarea", {
                                                    class: "form-control",
                                                    id: "offerFooter4",
                                                    style: { "height": "100px" },
                                                    "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event) => ((_unref(settingsForm).offerFooter4) = $event))
                                                }, null, 512), [
                                                    [_vModelText, _unref(settingsForm).offerFooter4]
                                                ]),
                                                _cache[120] || (_cache[120] = _createElementVNode("label", { for: "offerFooter4" }, "Fußzeile - Spalte 4", -1))
                                            ])
                                        ])
                                    ]),
                                    _cache[130] || (_cache[130] = _createElementVNode("button", {
                                        type: "submit",
                                        class: "btn btn-success d-inline-flex align-items-center"
                                    }, [
                                        _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "16",
                                            height: "16",
                                            fill: "currentColor",
                                            class: "bi bi-check2",
                                            viewBox: "0 0 16 16"
                                        }, [
                                            _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                        ]),
                                        _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                    ], -1))
                                ], 32)
                            ]),
                            _createElementVNode("div", _hoisted_74, [
                                _createElementVNode("form", {
                                    onSubmit: _cache[53] || (_cache[53] = _withModifiers(($event) => (updateStripe()), ["prevent"]))
                                }, [
                                    _createElementVNode("div", _hoisted_75, [
                                        _createElementVNode("div", _hoisted_76, [
                                            _createElementVNode("div", _hoisted_77, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "stripeKey",
                                                    "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event) => ((_unref(stripeForm).key) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(stripeForm).key]
                                                ]),
                                                _cache[131] || (_cache[131] = _createElementVNode("label", { for: "stripeKey" }, "Key", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_78, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "stripeSecret",
                                                    "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event) => ((_unref(stripeForm).secret) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(stripeForm).secret]
                                                ]),
                                                _cache[132] || (_cache[132] = _createElementVNode("label", { for: "stripeSecret" }, "Secret", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_79, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "stripeWebhookSecret",
                                                    "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event) => ((_unref(stripeForm).webhookSecret) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(stripeForm).webhookSecret]
                                                ]),
                                                _cache[133] || (_cache[133] = _createElementVNode("label", { for: "stripeWebhookSecret" }, "Webhook Secret", -1))
                                            ])
                                        ])
                                    ]),
                                    _cache[134] || (_cache[134] = _createElementVNode("button", {
                                        type: "submit",
                                        class: "btn btn-success d-inline-flex align-items-center"
                                    }, [
                                        _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "16",
                                            height: "16",
                                            fill: "currentColor",
                                            class: "bi bi-check2",
                                            viewBox: "0 0 16 16"
                                        }, [
                                            _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                        ]),
                                        _createElementVNode("span", { class: "ms-2" }, "Speichern & Testen")
                                    ], -1))
                                ], 32)
                            ]),
                            _createElementVNode("div", _hoisted_80, [
                                _createElementVNode("form", {
                                    onSubmit: _cache[59] || (_cache[59] = _withModifiers(($event) => (updateMailer()), ["prevent"]))
                                }, [
                                    _createElementVNode("div", _hoisted_81, [
                                        _createElementVNode("div", _hoisted_82, [
                                            _createElementVNode("div", _hoisted_83, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "mailerHost",
                                                    "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event) => ((_unref(mailerForm).mailerHost) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(mailerForm).mailerHost]
                                                ]),
                                                _cache[135] || (_cache[135] = _createElementVNode("label", { for: "mailerHost" }, "Host", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_84, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "mailerPort",
                                                    "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event) => ((_unref(mailerForm).mailerPort) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [
                                                        _vModelText,
                                                        _unref(mailerForm).mailerPort,
                                                        void 0,
                                                        { number: true }
                                                    ]
                                                ]),
                                                _cache[136] || (_cache[136] = _createElementVNode("label", { for: "mailerPort" }, "Port", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_85, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "mailerEncryption",
                                                    "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event) => ((_unref(mailerForm).mailerEncryption) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(mailerForm).mailerEncryption]
                                                ]),
                                                _cache[137] || (_cache[137] = _createElementVNode("label", { for: "mailerEncryption" }, "Verschlüsselung (z.B. tls)", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_86, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "mailerUsername",
                                                    "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event) => ((_unref(mailerForm).mailerUsername) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(mailerForm).mailerUsername]
                                                ]),
                                                _cache[138] || (_cache[138] = _createElementVNode("label", { for: "mailerUsername" }, "Benutzername", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_87, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "password",
                                                    class: "form-control",
                                                    id: "mailerPassword",
                                                    "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event) => ((_unref(mailerForm).mailerPassword) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(mailerForm).mailerPassword]
                                                ]),
                                                _cache[139] || (_cache[139] = _createElementVNode("label", { for: "mailerPassword" }, "Passwort", -1))
                                            ])
                                        ])
                                    ]),
                                    _cache[140] || (_cache[140] = _createElementVNode("button", {
                                        type: "submit",
                                        class: "btn btn-success d-inline-flex align-items-center"
                                    }, [
                                        _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "16",
                                            height: "16",
                                            fill: "currentColor",
                                            class: "bi bi-check2",
                                            viewBox: "0 0 16 16"
                                        }, [
                                            _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                        ]),
                                        _createElementVNode("span", { class: "ms-2" }, "Speichern & Testen")
                                    ], -1))
                                ], 32)
                            ]),
                            _createElementVNode("div", _hoisted_88, [
                                _createElementVNode("form", {
                                    onSubmit: _cache[64] || (_cache[64] = _withModifiers(($event) => (createAiPreviewOption()), ["prevent"])),
                                    enctype: "multipart/form-data"
                                }, [
                                    _createElementVNode("div", _hoisted_89, [
                                        _createElementVNode("div", _hoisted_90, [
                                            _createElementVNode("div", _hoisted_91, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "createAiOptionName",
                                                    "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event) => ((_unref(aiPreviewOptionForm).name) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(aiPreviewOptionForm).name]
                                                ]),
                                                _cache[141] || (_cache[141] = _createElementVNode("label", { for: "createAiOptionName" }, "Name", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_92, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "createAiOptionNameEn",
                                                    "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event) => ((_unref(aiPreviewOptionForm).nameEn) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(aiPreviewOptionForm).nameEn]
                                                ]),
                                                _cache[142] || (_cache[142] = _createElementVNode("label", { for: "createAiOptionNameEn" }, "Name (Englisch)", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_93, [
                                                _withDirectives(_createElementVNode("select", {
                                                    class: "form-select",
                                                    id: "createAiOptionCode",
                                                    "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event) => ((_unref(aiPreviewOptionForm).code) = $event))
                                                }, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.availableAiPreviewOptions, (option, index) => {
                                                        return (_openBlock(), _createElementBlock("option", { value: index }, _toDisplayString(option), 9, _hoisted_94));
                                                    }), 256))
                                                ], 512), [
                                                    [_vModelSelect, _unref(aiPreviewOptionForm).code]
                                                ]),
                                                _cache[143] || (_cache[143] = _createElementVNode("label", { for: "createAiOptionCode" }, "Typ", -1))
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_95, [
                                            _createElementVNode("div", _hoisted_96, [
                                                _createElementVNode("input", {
                                                    type: "file",
                                                    onInput: _cache[63] || (_cache[63] = ($event) => (_unref(aiPreviewOptionForm).imageFile = $event.target.files[0])),
                                                    class: "form-control",
                                                    id: "newAiPreviewOptionImageFile"
                                                }, null, 32),
                                                _cache[144] || (_cache[144] = _createElementVNode("label", { for: "newAiPreviewOptionImageFile" }, "Vorschaubild", -1))
                                            ])
                                        ])
                                    ]),
                                    _cache[145] || (_cache[145] = _createElementVNode("button", {
                                        type: "submit",
                                        class: "btn btn-success d-inline-flex align-items-center"
                                    }, [
                                        _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "16",
                                            height: "16",
                                            fill: "currentColor",
                                            class: "bi bi-check2",
                                            viewBox: "0 0 16 16"
                                        }, [
                                            _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                        ]),
                                        _createElementVNode("span", { class: "ms-2" }, "Anlegen")
                                    ], -1))
                                ], 32),
                                _cache[149] || (_cache[149] = _createElementVNode("hr", null, null, -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.aiPreviewOptions, (option) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: option.uuid,
                                        class: "mb-4 p-3 rounded border"
                                    }, [
                                        _createElementVNode("form", {
                                            onSubmit: _withModifiers(($event) => (updateAiPreviewOption(option)), ["prevent"]),
                                            enctype: "multipart/form-data"
                                        }, [
                                            _createElementVNode("div", _hoisted_98, [
                                                _createElementVNode("div", _hoisted_99, [
                                                    _createElementVNode("div", _hoisted_100, [
                                                        _withDirectives(_createElementVNode("input", {
                                                            type: "text",
                                                            class: "form-control",
                                                            id: 'editAiOptionName-' + option.uuid,
                                                            "onUpdate:modelValue": ($event) => ((option.name) = $event),
                                                            required: ""
                                                        }, null, 8, _hoisted_101), [
                                                            [_vModelText, option.name]
                                                        ]),
                                                        _createElementVNode("label", {
                                                            for: 'editAiOptionName-' + option.uuid
                                                        }, "Name", 8, _hoisted_102)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_103, [
                                                        _withDirectives(_createElementVNode("input", {
                                                            type: "text",
                                                            class: "form-control",
                                                            id: 'editAiOptionNameEn-' + option.uuid,
                                                            "onUpdate:modelValue": ($event) => ((option.nameEn) = $event),
                                                            required: ""
                                                        }, null, 8, _hoisted_104), [
                                                            [_vModelText, option.nameEn]
                                                        ]),
                                                        _createElementVNode("label", {
                                                            for: 'editAiOptionNameEn-' + option.uuid
                                                        }, "Name (Englisch)", 8, _hoisted_105)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_106, [
                                                        _withDirectives(_createElementVNode("select", {
                                                            class: "form-select",
                                                            id: 'editAiOptionCode-' + option.uuid,
                                                            "onUpdate:modelValue": ($event) => ((option.code) = $event)
                                                        }, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.availableAiPreviewOptions, (option, index) => {
                                                                return (_openBlock(), _createElementBlock("option", { value: index }, _toDisplayString(option), 9, _hoisted_108));
                                                            }), 256))
                                                        ], 8, _hoisted_107), [
                                                            [_vModelSelect, option.code]
                                                        ]),
                                                        _createElementVNode("label", {
                                                            for: 'editAiOptionCode-' + option.uuid
                                                        }, "Typ", 8, _hoisted_109)
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_110, [
                                                    _createElementVNode("div", _hoisted_111, [
                                                        _createElementVNode("div", _hoisted_112, [
                                                            _createElementVNode("div", _hoisted_113, [
                                                                _createElementVNode("input", {
                                                                    type: "file",
                                                                    onInput: ($event) => (option.imageFile = $event.target.files[0]),
                                                                    class: "form-control",
                                                                    id: 'editAiPreviewOptionNewImageFile-' + option.uuid
                                                                }, null, 40, _hoisted_114),
                                                                _createElementVNode("label", {
                                                                    for: 'editAiPreviewOptionNewImageFile-' + option.uuid
                                                                }, "Neues Vorschaubild", 8, _hoisted_115)
                                                            ])
                                                        ]),
                                                        _createElementVNode("div", _hoisted_116, [
                                                            (option.imageUrl)
                                                                ? (_openBlock(), _createElementBlock("img", {
                                                                    key: 0,
                                                                    src: option.imageUrl,
                                                                    class: "rounded",
                                                                    alt: "Aktuelles Vorschaubild",
                                                                    style: { "width": "150px" }
                                                                }, null, 8, _hoisted_117))
                                                                : _createCommentVNode("", true),
                                                            _cache[146] || (_cache[146] = _createElementVNode("p", { class: "form-text" }, "Aktuelles Vorschaubild", -1))
                                                        ])
                                                    ]),
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: "btn btn-danger d-inline-flex align-items-center",
                                                        onClick: ($event) => (removeAiPreviewOption(option))
                                                    }, [...(_cache[147] || (_cache[147] = [
                                                            _createElementVNode("svg", {
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                width: "16",
                                                                height: "16",
                                                                fill: "currentColor",
                                                                class: "bi bi-x-circle",
                                                                viewBox: "0 0 16 16"
                                                            }, [
                                                                _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }),
                                                                _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" })
                                                            ], -1),
                                                            _createElementVNode("span", { class: "ms-2" }, "Option löschen", -1)
                                                        ]))], 8, _hoisted_118)
                                                ])
                                            ]),
                                            _cache[148] || (_cache[148] = _createElementVNode("button", {
                                                type: "submit",
                                                class: "btn btn-success d-inline-flex align-items-center"
                                            }, [
                                                _createElementVNode("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "16",
                                                    height: "16",
                                                    fill: "currentColor",
                                                    class: "bi bi-check2",
                                                    viewBox: "0 0 16 16"
                                                }, [
                                                    _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                                ]),
                                                _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                            ], -1))
                                        ], 40, _hoisted_97)
                                    ]));
                                }), 128))
                            ])
                        ])
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
